var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgPersonalMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 29.8149L36 0L72 29.8149V72H0V29.8149Z",
    fill: "#2A5B43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2501 55.0847H11.7502C11.3871 55.0847 11.0928 54.7908 11.0928 54.428V6.79166C11.0928 6.4294 11.3871 6.1355 11.7502 6.1355H60.2501C60.6132 6.1355 60.9075 6.4294 60.9075 6.79166V54.428C60.9075 54.7908 60.6132 55.0847 60.2501 55.0847Z",
    fill: "#D6E8F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 32.5C17 31.6716 17.6716 31 18.5 31H53.0652C53.8936 31 54.5652 31.6716 54.5652 32.5C54.5652 33.3284 53.8936 34 53.0652 34H18.5C17.6716 34 17 33.3284 17 32.5Z",
    fill: "#2974B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.2173,
    y: 36.7827,
    width: 37.5652,
    height: 3,
    rx: 1.5,
    fill: "#2974B2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.2173,
    y: 42.261,
    width: 37.5652,
    height: 3,
    rx: 1.5,
    fill: "#2974B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 16.5C34 15.6716 34.6716 15 35.5 15H53.5C54.3284 15 55 15.6716 55 16.5C55 17.3284 54.3284 18 53.5 18H35.5C34.6716 18 34 17.3284 34 16.5Z",
    fill: "#2974B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 22.5C34 21.6716 34.6716 21 35.5 21H45.5C46.3284 21 47 21.6716 47 22.5C47 23.3284 46.3284 24 45.5 24H35.5C34.6716 24 34 23.3284 34 22.5Z",
    fill: "#2974B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 15H19C17.8954 15 17 15.8954 17 17V22C17 23.1046 17.8954 24 19 24H28C29.1046 24 30 23.1046 30 22V17C30 15.8954 29.1046 15 28 15Z",
    fill: "#2974B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 29.8149L29.8538 50.9077L0 72V29.8149Z",
    fill: "#3F936A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0002 29.8149L42.1465 50.9077L72.0002 72V29.8149Z",
    fill: "#3F936A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1712 50.9077H29.8538V50.8899L0 72H72L42.1712 50.9077Z",
    fill: "#3A8761"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPersonalMail);
export default __webpack_public_path__ + "static/media/imgPersonalMail.5a4fb2da6c49af18bfc846261e9af66f.svg";
export { ForwardRef as ReactComponent };